import React from "react";
import { motion } from "framer-motion";
import Papa from 'papaparse';
import { useEffect, useState } from 'react';


  export default function App() {
    const [projects, setProjects] = useState([]);
    const [visitorCount, setVisitorCount] = useState(0);
    useEffect(() => {
      Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vS-i8uU-3P270s8ItLy5-QmgXy8Ywep8Ds_iyRE0eoTFKR1VotIkkJnhWdEPnWTLh4V3rP2WtaErjr1/pub?output=csv", {
        download: true,
        header: true,
        complete: (results) => {
          setProjects(results.data);
        },
      });
      fetch("https://api.countapi.xyz/hit/portfolio-agung/visits")
        .then((res) => res.json())
        .then((data) => setVisitorCount(data.value))
        .catch((err) => {
          console.error("Visitor counter error:", err);
          setVisitorCount(0); // fallback default
        });
    }, []);
    return (
      <div className="min-h-screen bg-blue-50 text-gray-800">
        {/* Navbar */}
        <header className="bg-white shadow sticky top-0 z-50">
          <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
            <h1 className="text-xl font-bold text-blue-600">Agung Satriawan</h1>
            <nav className="space-x-4 hidden md:block">
              <a href="#about" className="text-sm font-medium hover:text-blue-500">About</a>
              <a href="#projects" className="text-sm font-medium hover:text-blue-500">Projects</a>
              <a href="#skills" className="text-sm font-medium hover:text-blue-500">Skills</a>
              <a href="#contact" className="text-sm font-medium hover:text-blue-500">Contact</a>
            </nav>
            <a href="../Agung CV Juni 2025_v3.pdf" className="text-sm font-semibold text-white bg-blue-500 px-4 py-2 rounded hover:bg-blue-600">Download CV</a>
          </div>
        </header>

        {/* Hero Section */}
        <section className="flex flex-col-reverse md:flex-row items-center justify-center text-center md:text-left py-20 px-4 gap-10 max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="flex-1"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-blue-700 mb-4">
              Hi, I'm Agung Satriawan
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mb-6">
              Web Developer & IT Support with 6+ years of experience
            </p>
            <a
              href="https://api.whatsapp.com/send?phone=6285117053498&text=Halo%20saya,%20ingin%20tahu%20tentang%20anda"
              className="inline-block bg-blue-500 text-white px-6 py-3 rounded-lg shadow hover:bg-blue-600 transition"
            >
              Contact Me
            </a>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="flex-1 flex justify-center"
          >
            <img
              src="../agung2.png"
              alt="Profile"
              className="w-60 h-60 rounded-full object-cover shadow-lg border-4 border-blue-300"

            />
          </motion.div>
        </section>

        {/* About Section */}
        <motion.section
          id="about"
          className="py-20 px-4 text-center"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h3 className="text-2xl font-semibold text-blue-600 mb-4">About Me</h3>
          <p className="max-w-2xl mx-auto text-gray-700">Lulusan SMK, belajar programming secara otodidak, berpengalaman dalam pengembangan sistem berbasis web, GIS, dan integrasi API. Fokus pada efisiensi dan solusi praktis.</p>
        </motion.section>

        {/* Projects Section */}
        <motion.section
          id="projects"
          className="py-20 px-4 text-center"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h3 className="text-2xl font-semibold text-blue-600 mb-4">Projects</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mt-10">
            {projects.map((project, index) => (
              <motion.div
                key={index}
                className="bg-white rounded-xl shadow-md p-6 text-left hover:shadow-lg transition"
                whileHover={{ scale: 1.03 }}
              >
                <img
                  src={'../' + project.image}
                  alt={project.title}
                  className="rounded-lg mb-4"
                />
                <h4 className="text-lg font-semibold text-blue-600 mb-2">{project.title}</h4>
                <p className="text-gray-600 text-sm mb-2">{project.description}</p>
                <div className="text-sm text-blue-500 space-x-3">
                  <a href={project.demo_url} className="hover:underline" target="_blank" rel="noopener noreferrer">Live Demo</a>
                  <a href={project.source_url} className="hover:underline" target="_blank" rel="noopener noreferrer">Source Code</a>
                </div>
              </motion.div>
            ))}

          </div>
        </motion.section>

        {/* Skills Section */}
        <motion.section
          id="skills"
          className="py-20 px-4 text-center"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h3 className="text-2xl font-semibold text-blue-600 mb-4">Skills</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 max-w-4xl mx-auto mt-10">
            {[
              { name: 'HTML5', color: 'text-orange-600' },
              { name: 'CSS3', color: 'text-blue-600' },
              { name: 'JavaScript', color: 'text-yellow-500' },
              { name: 'React', color: 'text-cyan-500' },
              { name: 'PHP', color: 'text-purple-600' },
              { name: 'Laravel', color: 'text-red-500' },
              { name: 'MySQL', color: 'text-blue-700' },
              { name: 'Tailwind CSS', color: 'text-sky-400' },
              { name: 'Bootstrap', color: 'text-indigo-500' },
              { name: 'jQuery', color: 'text-blue-400' },
              { name: 'WebGIS', color: 'text-green-600' },
              { name: 'API Integration', color: 'text-emerald-600' }
            ].map((skill, index) => (
              <motion.div
                key={index}
                className="bg-white p-4 rounded-lg shadow hover:shadow-md transition"
                whileHover={{ scale: 1.05 }}
              >
                <span className={`font-semibold ${skill.color}`}>{skill.name}</span>
              </motion.div>
            ))}
          </div>
        </motion.section>

        {/* Contact Section */}
        <motion.section
          id="contact"
          className="py-20 px-4 text-center"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h3 className="text-2xl font-semibold text-blue-600 mb-4">Contact</h3>
          <p className="text-gray-700"><a target="_blank" href="https://api.whatsapp.com/send?phone=6285117053498&text=Halo%20saya,%20ingin%20tahu%20tentang%20anda">Call Me</a></p>
        </motion.section>

        {/* Footer */}
        <footer className="bg-white border-t py-6 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} Agung Satriawan. All rights reserved. <br />
          <span className="text-gray-400">Total Visitors: {visitorCount}</span>
        </footer>
      </div>
    );
  }
